(() => {
  'use strict';
  if (window.toscaniPromoPopup) return;
  window.toscaniPromoPopup = true;

  const key = 'toscani:promo:BISCHERONE25:closed:v1';
  const cookieName = 'toscani_promo_bischerone25';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const controllers = new Map();
  let dismissed = false;

  function wasDismissed() {
    if (dismissed) return true;
    try { if (sessionStorage.getItem(key) === '1') return true; } catch { /* Cookie fallback below. */ }
    try { return document.cookie.split(';').some(part => part.trim() === cookieName + '=1'); }
    catch { return false; }
  }

  function rememberDismissal() {
    dismissed = true;
    try { sessionStorage.setItem(key, '1'); }
    catch {
      // A session cookie is used only when sessionStorage is unavailable.
      try { document.cookie = cookieName + '=1; Path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : ''); }
      catch { /* Dismissal still works if the browser blocks all storage. */ }
    }
  }

  function init(root = document) {
    root.querySelectorAll('[data-tsp-dialog]').forEach(dialog => {
      if (controllers.has(dialog) || typeof dialog.showModal !== 'function') return;
      const editor = dialog.dataset.tspEditor === 'true';
      const copy = dialog.querySelector('[data-tsp-copy]');
      const status = dialog.querySelector('[data-tsp-status]');
      const cleanups = [];
      let previousFocus = null, closeTimer = 0, restoreScroll = null, outsideDown = false;
      let copyPending = false, destroyed = false, frame = 0;

      function listen(target, type, handler, options) {
        target.addEventListener(type, handler, options);
        cleanups.push(() => target.removeEventListener(type, handler, options));
      }

      function lockScroll() {
        const page = document.documentElement;
        const hadStyle = page.hasAttribute('style');
        const properties = ['overflow', 'scrollbar-gutter', 'padding-right'];
        const saved = properties.map(name => [name, page.style.getPropertyValue(name), page.style.getPropertyPriority(name)]);
        const gutter = Math.max(0, window.innerWidth - page.clientWidth);
        if (window.CSS?.supports('scrollbar-gutter', 'stable')) page.style.setProperty('scrollbar-gutter', 'stable');
        else if (gutter) page.style.setProperty('padding-right', (parseFloat(getComputedStyle(page).paddingRight) + gutter) + 'px');
        page.style.setProperty('overflow', 'hidden');
        restoreScroll = () => {
          saved.forEach(([name, value, priority]) => {
            if (value) page.style.setProperty(name, value, priority);
            else page.style.removeProperty(name);
          });
          if (!hadStyle && !page.style.length) page.removeAttribute('style');
          restoreScroll = null;
        };
      }

      function cleanupClose() {
        clearTimeout(closeTimer);
        dialog.removeAttribute('data-tsp-closing');
        restoreScroll?.();
        if (previousFocus?.isConnected && previousFocus !== document.body) previousFocus.focus({ preventScroll: true });
        previousFocus = null;
      }

      function finishClose() {
        if (dialog.open) dialog.close();
        cleanupClose();
      }

      function close(immediate = false, remember = true) {
        if (!dialog.open || (!immediate && dialog.hasAttribute('data-tsp-closing'))) return;
        if (remember && !editor) rememberDismissal();
        if (immediate || reduced.matches) finishClose();
        else {
          dialog.setAttribute('data-tsp-closing', '');
          closeTimer = window.setTimeout(finishClose, 150);
        }
      }

      function open(force = false) {
        if (destroyed || !dialog.isConnected || dialog.open || (!force && (editor || wasDismissed()))) return;
        // Do not put an unstyled popup over the site if its stylesheet failed.
        if (getComputedStyle(dialog).getPropertyValue('--tsp-ready').trim() !== '1') return;
        if (document.querySelector('dialog[open]')) return;
        previousFocus = document.activeElement;
        status.textContent = '';
        dialog.querySelectorAll('img').forEach(img => { img.loading = 'eager'; });
        try {
          dialog.showModal(); // Native focus containment, Escape and background inertness.
          lockScroll();
        } catch {
          finishClose();
        }
      }

      function legacyCopy() {
        const field = document.createElement('textarea');
        field.className = 'tsp-clipboard';
        field.value = dialog.dataset.tspCode;
        field.readOnly = true;
        field.tabIndex = -1;
        field.setAttribute('aria-hidden', 'true');
        dialog.append(field);
        let success = false;
        try {
          field.focus({ preventScroll: true });
          field.select();
          field.setSelectionRange(0, field.value.length);
          success = document.execCommand('copy');
        } catch { /* The visible code remains selectable. */ }
        field.remove();
        copy.focus({ preventScroll: true });
        return success;
      }

      async function copyCode() {
        if (copyPending) return;
        copyPending = true;
        let copied = false;
        try {
          if (window.isSecureContext && navigator.clipboard?.writeText) {
            try { await navigator.clipboard.writeText(dialog.dataset.tspCode); copied = true; }
            catch { if (dialog.open) copied = legacyCopy(); }
          } else copied = legacyCopy();
          if (!destroyed && dialog.open) {
            status.textContent = copied ? 'Codice copiato!' : 'Tieni premuto BISCHERONE25 per copiarlo.';
            if (!copied) {
              const range = document.createRange();
              range.selectNodeContents(dialog.querySelector('[data-tsp-code-text]'));
              const selection = window.getSelection();
              selection?.removeAllRanges();
              selection?.addRange(range);
            }
          }
        } finally { copyPending = false; }
      }

      listen(dialog.querySelector('[data-tsp-close]'), 'click', () => close());
      listen(dialog.querySelector('[data-tsp-shop]'), 'click', () => close(true));
      listen(copy, 'click', copyCode);
      listen(dialog, 'pointerdown', event => { outsideDown = event.target === dialog; }, { passive: true });
      listen(dialog, 'click', event => {
        if (event.target === dialog && outsideDown) close();
        outsideDown = false;
      });
      listen(dialog, 'cancel', event => { event.preventDefault(); close(); });
      listen(dialog, 'close', () => {
        if (!editor && !destroyed) rememberDismissal();
        cleanupClose();
      });

      const controller = {
        open,
        close,
        destroy() {
          destroyed = true;
          cancelAnimationFrame(frame);
          clearTimeout(closeTimer);
          finishClose();
          cleanups.forEach(remove => remove());
          controllers.delete(dialog);
        }
      };
      controllers.set(dialog, controller);
      const styles = document.querySelector('[data-tsp-styles]');
      if (styles && !styles.sheet) listen(styles, 'load', () => open(), { once: true });
      frame = requestAnimationFrame(() => open());
    });
  }

  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    controllers.forEach((controller, dialog) => { if (event.target.contains(dialog)) controller.destroy(); });
  });
  document.addEventListener('shopify:section:select', event => {
    controllers.forEach((controller, dialog) => { if (event.target.contains(dialog)) controller.open(true); });
  });
  document.addEventListener('shopify:section:deselect', event => {
    controllers.forEach((controller, dialog) => { if (event.target.contains(dialog)) controller.close(true, false); });
  });
  window.addEventListener('pagehide', () => {
    controllers.forEach(controller => controller.close(true));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
})();
